import { MakeCall } from './createMakeCall';

export interface PartnerClickData {
  identity: string;
  eventTime: string;
}

export interface PartnerListingClick {
  url: string;
  signature: string;
}

const generateListingClick =
  (makeCall: MakeCall) => (listingId: number, data: PartnerClickData) =>
    makeCall<PartnerListingClick>(
      'POST',
      `/api/v2/listing/${listingId}/generate-click`,
      { data },
    );

export { generateListingClick };
